import '@mdi/font/css/materialdesignicons.css'
import 'vue3-calendar-heatmap/dist/style.css'
import '../css/app.css'
import {createApp, h} from 'vue'
import {createInertiaApp} from '@inertiajs/vue3'
import 'vuetify/styles'
import {createVuetify} from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import {VBtn} from 'vuetify/components/VBtn'
import {VTextField} from "vuetify/components/VTextField";
import VueCalendarHeatmap from 'vue3-calendar-heatmap'
import * as Sentry from "@sentry/vue";

const vuetify = createVuetify({
    aliases: {
        SubmitBtn: VBtn,
        ErrorBtn: VBtn,
        SuccessBtn: VBtn,
        DefaultBtn: VBtn,
        TextBtn: VBtn,
        SearchInput: VTextField,
    },
    defaults: {
        SearchInput: {
            variant: 'outlined',
            density: 'compact',
            rounded: 'md',
            hideDetails: true,
            color: 'blue',
            persistentPlaceholder: true,
            class: 'bg-grey-lighten-4',
        },
        SubmitBtn: {
            color: 'success',
            variant: 'flat',
            class: 'text-none text-body-2',
            type: 'submit',
            rounded: 'lg'
        },
        SuccessBtn: {
            color: 'success',
            variant: 'flat',
            class: 'text-none text-body-2',
            type: 'btn',
            rounded: 'md',
        },
        ErrorBtn: {
            color: 'error',
            variant: 'flat',
            class: 'text-none text-body-2',
            type: 'btn',
            rounded: 'md',
        },
        DefaultBtn: {
            color: 'grey-lighten-4',
            variant: 'flat',
            class: 'text-none text-body-2',
            type: 'btn',
            rounded: 'lg',
            border: 'sm',
        },
        TextBtn: {
            color: 'primary',
            variant: 'text',
            class: 'text-none text-body-2',
            type: 'btn',
            rounded: 'md',
        }
    },
    components: {
        ...components,
    },
    directives,
})

createInertiaApp({
    progress: {
        delay: 250,
        color: '#29d',
        top: '64px',
        includeCss: true,
        showSpinner: false,
    },
    resolve: name => {
        const pages = import.meta.glob('./Pages/**/*.vue', {eager: true})
        return pages[`./Pages/${name}.vue`]
    },
    setup({el, App, props, plugin}) {
        const app = createApp({render: () => h(App, props)})

        Sentry.init({
            app,
            dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.feedbackIntegration({
                    // Additional SDK configuration goes in here, for example:
                    colorScheme: "light",
                    useSentryUser: {
                        name: "fullName",
                        email: "email",
                    },
                    triggerLabel: null,
                    autoInject: false,
                    themeLight: {
                        accentBackground: "#40A33F",
                    }
                }),
            ],

            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for tracing.
            // We recommend adjusting this value in production
            tracesSampleRate: 0.1,

            // Capture Replay for 10% of all sessions,
            // plus for 100% of sessions with an error
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
        });

        app.use(plugin)
            .use(VueCalendarHeatmap)
            .use(vuetify)
            .mount(el)
    },
})
